import { createI18n } from 'vue-i18n';

import appAdmin from '@/AppAdmin/translation';
import app from '@/App/translation';

import auth from './auth';

import en from './en.json';
import vi from './vi.json';

const messages = {
  en: {
    ...en,
    ...auth.en,
    ...appAdmin.en,
    ...app.en
  },
  vi: {
    ...vi,
    ...auth.vi,
    ...appAdmin.vi,
    ...app.vi
  }
};

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  messages
});

export default i18n;
